<template>
  <div id="app">
    <Head></Head>
    <Banner v-if="flag"></Banner>
    <Content v-else></Content>
    <router-view />
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "./components/Head.vue";
import Foot from "./components/Foot.vue";
import Banner from "./components/Banner.vue";
import Content from "./components/Content.vue";
export default {
  name: "App",
  components: {
    Head,
    Foot,
    Banner,
    Content
  },
  data() {
    return {
      flag: false
    };
  },
  created() {
    const href = window.location.href
    const arr = href.split('#')
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (val.meta.path === "home") {
          this.flag = true;
        }else {
          this.flag = false
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less">
@import "./index.less";
@import "./css/color.less";
#app {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue